import { getCookie } from 'Utilities/Cookies'
import { useSettingsStore } from 'Store/settings'

export function collectAdditionalDetails() {
  const settingsStore = useSettingsStore()
  const settings = settingsStore.getSettings
  const facilityVariables = settings.variables || {}
  const gtmVariables = facilityVariables.gtm || []
  const cookieVariables = facilityVariables.cookie || []
  const dataAttributeVariables = facilityVariables.data_attribute || []

  const additionalDetails = {
    gtm: {},
    cookie: {},
    data_attribute: {}
  }

  if (gtmVariables.length) {
    const gtmID = settings.gtm_id
    const isGTMAvailable = gtmID && window.google_tag_manager && window.google_tag_manager[gtmID]

    gtmVariables.forEach((key) => {
      const value = isGTMAvailable ? window.google_tag_manager[gtmID].dataLayer.get(key) : null
      additionalDetails.gtm[key] = value || null
    })
  }

  cookieVariables.forEach((key) => {
    const value = getCookie(key)
    additionalDetails.cookie[key] = value || null
  })

  dataAttributeVariables.forEach((key) => {
    const value = settingsStore.scriptDataAttributes[key]
    additionalDetails.data_attribute[key] = value || null
  })

  return additionalDetails
}
